<template>
  <v-text-field
    v-model="inputedValue"
    class="pt-2 mr-3"
    :label="label"
    type="number"
    style='max-width: 70px;'
    :rules="[presenceValidation, positiveNumberPresenceValidation]"
  />
</template>

<script>
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [formValidationUtils],
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    }
  },
  computed: {
    inputedValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
